import { mechanicsRings, trackingSteps } from "@/mocks/gua";

export default function Mechanics() {
  return (
    <section id="mechanics" className="bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col items-center text-center">
          <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-radar-line"></i>辐射玩法
          </span>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            以事件为圆心，逐层向外扩散
          </h2>
          <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            一只瓜从不孤立。跟着我们的辐射地图，从中心瓜一路追到关联人物、背景故事与全网扩散。
          </p>
        </div>

        <div className="relative mt-12 overflow-hidden">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
            {mechanicsRings.map((ring, idx) => (
              <div key={ring.title} className="relative flex flex-col">
                <div className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-transform duration-300 hover:-translate-y-1">
                  <div className="flex items-center justify-between">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                      <i className={`${ring.icon} text-lg`}></i>
                    </span>
                    <span className="font-heading text-sm font-bold text-background-300">
                      第{idx + 1}环
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                    {ring.title}
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">{ring.desc}</p>
                </div>
                {idx < mechanicsRings.length - 1 && (
                  <div className="pointer-events-none absolute -right-3 top-1/2 z-10 hidden h-8 w-6 -translate-y-1/2 items-center justify-center text-primary-400 lg:flex">
                    <i className="ri-arrow-right-line text-lg"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 overflow-hidden rounded-2xl border border-background-200 bg-background-100">
          <div className="flex flex-col lg:flex-row">
            <div className="flex flex-col justify-center gap-6 px-6 py-10 md:px-10 lg:w-[38%]">
              <div>
                <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
                  <i className="ri-route-line"></i>五步追踪法
                </span>
                <h3 className="font-heading text-2xl font-black text-foreground-950">
                  扩散路径，一步一步追
                </h3>
                <p className="mt-3 text-sm leading-7 text-foreground-600">
                  从锁定中心瓜到持续跟进反转，我们把热点追踪拆成清晰可执行的五步，
                  让你既能看懂当前瓜的方位，也不会错过它的下一次转折。
                </p>
              </div>
              <div className="relative h-40 overflow-hidden rounded-xl bg-primary-900">
                <img
                  src="https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20person%20with%20a%20magnifying%20glass%20following%20a%20curved%20map%20path%20with%20milestone%20dots%2C%20warm%20cream%20background%20with%20tomato%20red%20and%20gold%20accents%2C%20minimal%20modern%20graphic&width=640&height=400&seq=mech-side-panel&orientation=landscape"
                  alt="按五步路径追踪热点扩散过程"
                  className="absolute inset-0 h-full w-full object-cover object-top"
                />
              </div>
            </div>

            <div className="grid gap-x-8 gap-y-7 border-t border-background-200 bg-background-50 px-6 py-10 md:px-10 lg:w-[62%] lg:border-l lg:border-t-0">
              {trackingSteps.map((s) => (
                <div key={s.step} className="flex gap-4">
                  <span className="font-heading text-3xl font-black leading-none text-primary-300">
                    {s.step}
                  </span>
                  <div>
                    <h4 className="font-heading text-base font-bold text-foreground-950">{s.title}</h4>
                    <p className="mt-1.5 text-sm leading-6 text-foreground-600">{s.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}